import React, { useEffect } from 'react';
import TopBar from './TopBar';
import ProductIntakeForm from './ProductIntakeForm'
import { AppLayout, Header, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { scan_alias_api } from '../utils/constants';

export default function RegisterPage(props: any) {
  // this function fetches data from the alias csv file
  async function getEmpData(ft: string) {
    if (ft.length < 3)
      return;
    let request: any;
    request = {};
    request["action"] = "get_alias_list";
    request["filter_text"] = ft;

    try {
      const response = await fetch(scan_alias_api, {
        mode: 'cors',
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'Authorization': props.userInfo.jwt,
        },
        body: JSON.stringify(request)
      });

      response.json().then(Data => {
        console.log(Data.alias_list);

      })
    }
    // TODO: Handle the error more gracefully by adding a pop up
    catch (err) {
      console.log(err);
    }
  }

  // making a call to warmup the lambda
  // fetching the data using useEffect hook
  useEffect(() => {
    getEmpData("test")
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    
    <div>
      <TopBar userInfo={props.userInfo} />
      
      <Header
          
          variant="h1"
          description="Register your 3P application/product/service with the TPPS team by filling out the form below"
        >
          Create Product Registration

        </Header>
      <AppLayout
      
        contentType="form"
       
        content={<ProductIntakeForm userInfo={props.userInfo} />}
        navigationHide={true}
        toolsHide={true}
      />
    </div>
  );
}